/**
 * #389 — identificadores de clique da Meta pra Conversions API.
 *
 * `_fbp`/`_fbc` são cookies do pixel (fbevents.js grava no domínio raiz, então o
 * que a landing WP gravou em coracoespreciosos.com.br chega aqui). Se o clique
 * caiu direto no checkout com `?fbclid=` e o cookie ainda não existe, o fbc é
 * montado no formato da Meta (`fb.1.<ms>.<fbclid>`) e guardado na sessão — o
 * router pode tirar a query da URL antes do passo 1.
 *
 * Vão em claro pro backend (a spec da Meta proíbe hashear fbc/fbp) e o backend
 * descarta o que estiver fora do formato. Nada aqui pode quebrar o checkout.
 */
const STORAGE_KEY = 'cp_meta_fbc';

function readCookie(name: string): string | undefined {
  try {
    const match = document.cookie
      .split('; ')
      .find((c) => c.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.slice(name.length + 1)) : undefined;
  } catch {
    return undefined;
  }
}

/** Chamar na carga da página, antes do router mexer na URL. */
export function captureFbclid(): void {
  try {
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (!fbclid) return;
    const stored = sessionStorage.getItem(STORAGE_KEY);
    // Mesmo clique (reload): mantém o timestamp original
    if (stored?.endsWith(`.${fbclid}`)) return;
    sessionStorage.setItem(STORAGE_KEY, `fb.1.${Date.now()}.${fbclid}`);
  } catch {
    // storage bloqueado (aba anônima/WebView): segue só com o cookie
  }
}

export function getMetaClickIds(): { fbc?: string; fbp?: string } {
  let storedFbc: string | undefined;
  try {
    storedFbc = sessionStorage.getItem(STORAGE_KEY) || undefined;
  } catch {
    storedFbc = undefined;
  }
  const fbc = readCookie('_fbc') || storedFbc;
  const fbp = readCookie('_fbp');
  return {
    ...(fbc && { fbc }),
    ...(fbp && { fbp }),
  };
}

/** event_id do Lead — o backend manda o mesmo (`lead_<clientId>`) pra dedup. */
export const leadEventId = (clientId: string): string => `lead_${clientId}`;
